import { MODAL_TYPES, ModalType } from "../../constants";
import { ClearLocationModal } from "../modals/ClearLocationModal";

interface ClearLocationModalWrapperProps {
  currentModal: ModalType;
  isModalOpen: (modalType: ModalType) => boolean;
  locationId: number | null;
  storedCraneId: number;
  onClose: () => void;
  refreshInterval?: number;
}

export const ClearLocationModalWrapper = ({
  currentModal,
  isModalOpen,
  locationId,
  storedCraneId,
  onClose,
  refreshInterval = 5,
}: ClearLocationModalWrapperProps) => {
  const show =
    currentModal === MODAL_TYPES.CLEAR_LOCATION ||
    isModalOpen(MODAL_TYPES.CLEAR_LOCATION);

  if (!locationId || !storedCraneId) return null;

  return (
    <ClearLocationModal
      show={show}
      onHide={onClose}
      locationId={locationId}
      selectedCraneId={storedCraneId}
      refreshInterval={refreshInterval}
    />
  );
};
